import {Component, OnInit} from '@angular/core';
import { NavigationService } from '../../../core/services/navigation/navigation.service';
import { AppState, selectAuthState } from 'src/store/reducers';
import { Observable } from 'rxjs/Observable';
import { Logout } from 'src/store/actions/authenticationActions';
import { DefaultUser } from 'src/store/actions/userActions';
import { LoginService } from 'src/app/pages/login/login.service'
import { LanguageService } from 'src/app/core/services/language/language.service';
import { Store } from '@ngrx/store';
@Component({
  selector: 'app-header',
  templateUrl: './header.component.html',
  styleUrls: ['./header.component.scss'],
})
export class HeaderComponent implements OnInit {
  getState: Observable<any>;
  loginState;
  registerState;
  user;
  defaultState;
  isCollapsed = false;
  navbarOpen = false;
  selectedLang;
  constructor(
    private loginService : LoginService,
    private navigation: NavigationService, 
    private store: Store<AppState>,
    private languageService: LanguageService
  ) 
  {
    
    this.getLanguage();    
    this.getState = this.store.select(selectAuthState);
  }

  ngOnInit() {
    this.getState.subscribe((state) => {
      
      this.loginService.getMessage().subscribe(d=>{
        if(d){
          this.user.isAuthenticated = true;
        }
      })
      // this.isAuthenticated = state.isAuthenticated;
      this.user = state;
      if(state.action === 'logout')
      {
        localStorage.removeItem("token");
        localStorage.removeItem("name");
        this.store.dispatch(new DefaultUser({}));
        this.navigation.navigateTo("/");
      }
    });

    // this.loginState.subscribe(state => {
    //   // if(!state.isAuthenticated && state.success === null)
    //   // {
      //   localStorage.removeItem("token");
      //   this.navigation.navigateTo("/");
    //   // }
    //   this.user = state;
    // });
  
  }
  // toggleCollapsed(): void {
  //   this.isCollapsed = !this.isCollapsed;
  // }
  toggleNavbar() {
    this.navbarOpen = !this.navbarOpen;
  }

  changeLang(lang) {
    this.languageService.setLanguageForApp(lang)
  }

  getLanguage(){
    this.selectedLang = this.languageService.getLanguage();
    console.log(this.selectedLang,"language");
  }
  login()
  {
    this.navigation.navigateTo('login');
    
  }
  signup()
  {
    this.navigation.navigateTo('signin');
  }
  logout()
  {
    this.store.dispatch(new Logout({}));
  }
  main()
  {
    this.navigation.navigateTo('dashboard');
  }
  profile()
  {
    this.navigation.navigateTo('dashboard');
  }
 
}
